import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";
import { PDFExport} from "@progress/kendo-react-pdf";
import Moment from 'moment';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import PageTemplate from "Routes/pdfTemplate";

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';



import {  
    allInjuryChart,
   getstudentinjurylist,
   fetchInjuryDetails
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';



class injurychartreport extends Component {
   
    constructor(props) {
        
        super(props);
        this.inputRefs = {
            [1]: React.createRef(),
            [2]: React.createRef(),
            [3]: React.createRef(),
            [4]: React.createRef(),
            [5]: React.createRef(),
            [6]: React.createRef(),
            [7]: React.createRef(),
            [8]: React.createRef(),
            [9]: React.createRef(),
            [10]: React.createRef(),
            [11]: React.createRef(),
            [12]: React.createRef(),
            [13]: React.createRef(),
            [14]: React.createRef(),
            [15]: React.createRef(),
          };
            
            this.nodeRef = React.createRef();
            this.confirmationDialog = React.createRef();
            this.state = {
                viewdiv:true,
                succdiv:false,
                student:'',
                accordionContent:[],
                heightProportion: 0,
                widthProportion: 0
            };  
        
        this.selectorRef = React.createRef(null);
        this.onBackSection = this.onBackSection.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.allInjuryChart();
	}

    // updateDimensions() {
    //     if (!this.nodeRef) return;
    //     const node = this.nodeRef.current;
    //     const nodewidth = node.offsetWidth;
    //     //const nodeheight = node.offsetHeight+300;
    //     this.setState({
    //       //heightProportion: nodeheight,
    //       widthProportion: nodewidth
    //     });

    //     const currentRef = this.inputRefs[this.state.currentSlide];
    //     if (currentRef && currentRef.current) {
    //     const height = currentRef.current.offsetHeight;
    //     this.setState({ heightProportion: height });
    //     }
    // }

    updateDimensions() {
  if (!this.nodeRef || !this.nodeRef.current) return;

  const node = this.nodeRef.current;
  const nodewidth = node.offsetWidth;

  this.setState({ widthProportion: nodewidth });

  const currentRef = this.inputRefs[this.state.currentSlide];
  if (currentRef && currentRef.current) {
    const height = currentRef.current.offsetHeight;
    this.setState({ heightProportion: height });
  }
}


    selectquarter(evt){
        var selstudent=evt.value;
        if(selstudent!=''){
            this.setState({ student : selstudent});
            this.props.getstudentinjurylist(selstudent).then((data) => {   
                this.setState({ viewdiv : true});
            });
           
        }
    }

    addHandleReport(rowid){
        
        this.props.fetchInjuryDetails(rowid).then((data) => { 
                this.setState({ 
                    viewdiv:false,
                    errordiv:false,
                    succdiv:true 
                });  
                this.updateDimensions();

        });
        
    }

    onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true
          });
	} 
    
    exportPDFWithMethod = () => {
        this.selectorRef.current.save();
    }

    exportPDFWithDynamic(ids){
       
        this.inputRefs[ids].current.save();
    }

   


    onBackSection() {
		this.setState({ 
            succdiv:false,
            maindiv:true,
            viewdiv:true,
         });
	}

    render() {
       const { match, injurychartlists, injuryfulldetails, injuryallupdates, loading } = this.props;
        
      

       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "No" },
            { name: "name", label: "Name" },
            { name: "date", label: "Date" },
            { name: "report", label: "Report" }
        ];
        const tabledata=injurychartlists.map((assmntval,idx) => {            
            
                const ebtn=   <MatButton
        key={idx}
        variant="contained"
        color="error"              // MUI red
        className="btn-icon mr-15 mb-10"  // remove btn-google & text-white
        onClick={() => this.addHandleReport(assmntval.sicID)}
      >
        <i className="zmdi zmdi-file-text"></i> Report
      </MatButton>;
             
                return {
                no:idx+1,
                name: assmntval.student,
                date: assmntval.cdate,
                report: ebtn
                }
        });

        const formatDate = Moment(injuryfulldetails.sic_date).format('DD/MM/YYYY   hh:mm a');
        const uptcnt=injuryallupdates.length;
    
        const styles = {
            table: {
                border: "1px solid black",
                borderColor:"black",
                borderStyle:"solid",
                fontFamily: "Arial",            
                zIndex:"100"
            },
            tablelefthead:{
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                whiteSpace: "pre-line",
                wordWrap: "break-word",            
                textAlign: "left",
                width:"30%",
                fontWeight:"bold",
                fontSize:"18px"
            },
            tabletrtd: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                whiteSpace: "pre-line",
                wordWrap: "break-word",            
                textAlign: "left",
                fontSize:"16px"
            },
            rctcontent:{
            
                marginTop:"80px",
                borderRadius: "5px",
                boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
                border: "none",
                transition: "all 0.4s ease-in-out 0s",
                marginBottom: "50px"
    
            }
        };
       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Injury Report and Updates | {AppConfig.appTitle}</title>
                <meta name="description" content="Sport Science Team" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.injurychartreportheading" />} match={match} />


                {this.state.viewdiv && 
                  <div className="col-sm-12 col-md-8">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable                              
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>  
                } 

                {this.state.succdiv &&
                    <div className="row">
                    <div className="col-sm-12 col-md-6">   
                        <div className="example-config">
                            <button
                            className="mr-3 mb-3 btn btn-outline-primary"
                            onClick={this.exportPDFWithMethod}
                            >
                            Export PDF
                            </button>

                            <button
                            className="mr-3 mb-3 btn btn-outline-warning float-right"
                            onClick={this.onBackSection}
                            >
                            Back
                            </button>
                        
                        </div>
                        <PDFExport   
                            pageTemplate={PageTemplate}                    
                            scale={0.6}
                            paperSize="A4"
                            margin="1.5cm"                           
                            fileName="Injury Report"
                            ref={this.selectorRef}
                            forcePageBreak=".page-break" 
                            >  
                            <div style={styles.rctcontent}  >
                                <div className="collapse show">
                                    <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>
                                        <div className="row justify-content-center reportdiv">
                                            <h1 className="text-center" style={{marginTop:"20px", marginBottom:"20px"}}> Injury Report</h1>
                                            <table className="table align-items-center table-flush" style={styles.table}>                                            
                                                <tbody>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Name 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {injuryfulldetails.student}
                                                    </td>                                                   
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Date and Time
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                    {formatDate}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Age / Gender
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {injuryfulldetails.sic_age} / {injuryfulldetails.sic_gender==1?'Male':'Female'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Skill
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_skill}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Chief Complaint
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_chief_complaint}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Mechanism Of Injury
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_mechanism_injury}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    History of Present Injury
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_history_present_injury}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    History of Similar Injury in the Past
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_history_injury_past}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Clinical Assessment and Observations
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_observations_assessment}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                     Clinical Findings
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_clinical_findings}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Provisional Diagnosis
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_provisional_diagnosis}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Injury Severity
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_injury_severity}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Further Consultation (if any)
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_consultation_investigations}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Plan Of Action
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_plan_action}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Restrictions (if any)
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_restrictions}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Expected time for Return to Sports
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_return_sports}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Notes for S&C Team
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_sc_team}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Notes for Coaching Team
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                         {injuryfulldetails.sic_coaching_team}
                                                    </td>
                                                </tr>
                                                
                                                
                                                </tbody>
                                            </table>
                                            <div className="col-md-12" style={{marginTop:"80px"}}>
                                                <p style={{fontSize:"20px"}}>{injuryfulldetails.sc_name}</p>
                                                <p style={{whiteSpace:"pre-wrap",fontSize:"20px"}}>{injuryfulldetails.sc_designation}</p>
                                                <p style={{marginTop:"20px",fontSize:"20px", fontWeight:"300"}}>{'{e}'} {injuryfulldetails.sc_email}</p>
                                                <p style={{fontWeight:"300",fontSize:"20px"}}>{'{p} +91'} {injuryfulldetails.sc_phone}</p>
                                            </div>                                            
                                        </div>
                                    </div>
                                </div>        
                            </div> 
                        </PDFExport>
                    </div> 
                    { uptcnt!=0 ? (
                    <div className="col-sm-12 col-md-6" ref={this.nodeRef}>
                        <CarouselProvider                            
                            naturalSlideWidth={this.state.widthProportion}
                            naturalSlideHeight={this.state.heightProportion}
                            totalSlides={uptcnt}
                            isIntrinsicHeight={true}
                            >
                          <div className="sdfsdf">
                            <ButtonBack className="mr-3 mb-3 btn btn-outline-primary">Prev</ButtonBack>
                            <ButtonNext className="mr-3 mb-3 btn btn-outline-primary float-right">Next</ButtonNext>
                            <div className="text-center" style={{marginTop:"-30px"}}>
                                {injuryallupdates.map((uptval,idx) => ( 
                                    <Dot className="text-center" slide={idx} >{idx+1}</Dot>
                                ))}
                            </div>                        
                        </div>
                         <Slider>    
                         
                        {injuryallupdates.map((uptval,idx) => (                                  
                                <Slide index={idx}> 
                                <button
                                    className="mr-3 mb-3 btn btn-outline-success"
                                    onClick={() => this.exportPDFWithDynamic(idx+1)}
                                    >
                                    Export PDF
                                </button>
                                <PDFExport   
                                    pageTemplate={PageTemplate}                    
                                    scale={0.6}
                                    paperSize="A4"
                                    margin="1.5cm"                           
                                    fileName="Injury Update"
                                    forcePageBreak=".page-break" 
                                    ref={this.inputRefs[idx+1]}
                                >
                                <div style={styles.rctcontent} >
                                    <div className="collapse show">
                                        <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>
                                            <div className="row justify-content-center reportdiv">
                                                <h1 className="text-center" style={{marginTop:"20px", marginBottom:"20px"}}> Injury Update</h1>
                                                <table className="table align-items-center table-flush" style={styles.table}>                                            
                                                    <tbody>
                                                    <tr>
                                                        <td style={styles.tablelefthead}>
                                                            Name 
                                                        </td>
                                                        <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.student}
                                                        </td>                                                   
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tablelefthead}>
                                                            Date and Time
                                                        </td>
                                                        <td style={styles.tabletrtd}>
                                                        {Moment(uptval.siu_date).format('DD/MM/YYYY   hh:mm a')} 
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tablelefthead}>
                                                            Age / Gender
                                                        </td>
                                                        <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_age} / {injuryfulldetails.sic_gender==1?'Male':'Female'}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tablelefthead}>
                                                        Provisional Diagnosis
                                                        </td>
                                                        <td style={styles.tabletrtd}>
                                                            {uptval.siu_provisional_diagnosis}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tablelefthead}>
                                                        Injury Severity
                                                        </td>
                                                        <td style={styles.tabletrtd}>
                                                            {uptval.siu_injury_severity}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tablelefthead}>
                                                        Update on Rehabilitation
                                                        </td>
                                                        <td style={styles.tabletrtd}>
                                                            {uptval.siu_update_rehabilitation}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tablelefthead}>
                                                        Plan Of Action
                                                        </td>
                                                        <td style={styles.tabletrtd}>
                                                            {uptval.siu_plan_action}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tablelefthead}>
                                                        Note for S&C Team
                                                        </td>
                                                        <td style={styles.tabletrtd}>
                                                            {uptval.siu_note_sc_team}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tablelefthead}>
                                                        Note for Coaching Team
                                                        </td>
                                                        <td style={styles.tabletrtd}>
                                                            {uptval.siu_note_coaching_team}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tablelefthead}>
                                                        Note for Team TSG
                                                        </td>
                                                        <td style={styles.tabletrtd}>
                                                            {uptval.siu_note_tsg_team}
                                                        </td>
                                                    </tr>
                                                    
                                                    
                                                    </tbody>
                                                </table>
                                                <div className="col-md-12" style={{marginTop:"80px"}}>
                                                    <p style={{fontSize:"20px"}}>{uptval.sc_name}</p>
                                                    <p style={{whiteSpace:"pre-wrap",fontSize:"20px"}}>{uptval.sc_designation}</p>
                                                    <p style={{marginTop:"20px",fontSize:"20px", fontWeight:"300"}}>{'{e}'} {uptval.sc_email}</p>
                                                    <p style={{fontWeight:"300",fontSize:"20px"}}>{'{p} +91'} {uptval.sc_phone}</p>
                                                </div>                                            
                                            </div>
                                        </div>
                                    </div>        
                                </div>
                            </PDFExport>  

                            
                            </Slide>
                                                        
                        ))}
                         </Slider>
                       
                    </CarouselProvider>
                    </div>
                    ):(" ")
                    }
                      
                    </div>
                } 
               
            
          </div>
       )
    }
 }




const mapStateToProps = ({ injurychart  }) => {
    const { injurychartlists, injuryfulldetails, injuryallupdates, loading } = injurychart;
	return {  injurychartlists, injuryfulldetails, injuryallupdates, loading };
}

export default connect(mapStateToProps, {
    allInjuryChart,
    getstudentinjurylist,
    fetchInjuryDetails
})(injurychartreport); 